module.exports = __webpack_public_path__ + "static/media/tv-retro.9622cb58.svg";